import { useContext, useEffect, useState } from "react";
import styled from 'styled-components';

import { formatDate, formatDateTime, formatTime } from "../../../Controllers/utils";
import { Header, WarningText } from "../../../Global/StyledComponents/UserFormStyledComponents";
import { Line } from "../../../Global/StyledComponents/AppStyledComponents";
import Loading from "../../../Global/Components/LoadingSpinner";
import { StateContext } from "../../../Controllers/context/state";
import supabase from "../../../Controllers/utils/supabaseClient";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 15px;
    position: relative;
    overflow: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        display: none;
        overflow: hidden;
    }
`;

const ChartInfoWindow = ({ setShowChartInfoWindow }) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const {
        chartInfo,
        logError,
    } = useContext(StateContext);

    useEffect(() => {
        const fetchSummaries = ({ retry = true }) => {
            supabase.rpc('get_summaries_by_aggr_timestamp', {
                    _aggr: chartInfo?.aggr, 
                    _symbol: chartInfo?.symbol,
                    _epoch: chartInfo?.timestamp / 1000,
                }).then(res => {
                    if (res?.error) {
                        const error = new Error(res?.error?.message);
                        logError(error.message, undefined, error);
    
                        if (retry) {
                            fetchEntities({ retry: false });

                            return;
                        }

                        setShowChartInfoWindow(false);

                        return;
                    }
    
                    setData(res?.data?.[0])
                    setLoading(false);
                });
        };

        fetchSummaries({ retry: true });
    }, []);


    if (loading) {
        return (
            <Container>
                <Loading />
            </Container>
        );
    }

    return (
        <Container>
            {data ?
                <>
                    <Header>
                        {data?.name} ({data?.symbol})
                    </Header>
                    <h3 style={{ width: 'fit-content'}}>
                        {chartInfo?.aggr === 'dtm' ?
                            formatDate(data?.ts) :
                            `${formatDateTime(data?.ts)} - ${formatTime(data?.ts + 600000)}`
                        }
                    </h3>
                    <Line />
                    <div style={{ margin: 3}}>
                        {data?.aggr_summary}
                    </div>
                    <Line />
                    {data?.mdl_outputs?.map(output => (
                        <>
                            <div style={{ margin: 3, width: '100%'}}>
                                <h2 style={{ margin: 0, padding: 0}}>
                                    {output?.name}
                                </h2>
                                <div>
                                    {output?.summary}
                                </div>
                            </div>
                            <Line />
                        </>
                    ))}
                </> :
                <WarningText>
                    No Available Data
                </WarningText>
            }
        </Container>
    )
};

export default ChartInfoWindow;
